import { useAgentProfile } from './useAgentProfile';
import { AgentProfile } from 'ui/components/common/patterns/AgentProfile/AgentProfile';

/**
 * 売り手企業が見る仲介企業のプロフィール
 */
export const CompanyAgentProfile: React.FC = () => {
    const { agent } = useAgentProfile();
    if (!agent) return null;

    return <AgentProfile agent={agent} />;
};
